import { useUser } from "@auth0/nextjs-auth0/client";
import PropTypes from "prop-types";
import React from "react";

const AuthWrapper = ({ children, shouldRenderOnUserSession = false }) => {
  const { error, isLoading, user } = useUser();

  const hasSession = !error && !isLoading && !!user;

  if (
    (shouldRenderOnUserSession && hasSession) ||
    (!shouldRenderOnUserSession && !hasSession)
  ) {
    return children;
  }

  return <div className="auth-wrapper-empty d-none"></div>;
};

AuthWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  shouldRenderOnUserSession: PropTypes.bool,
};

export default AuthWrapper;
